<div class="header">
  @if (configuration?.header) {
    <h3 class="card__title">{{ configuration?.header }}</h3>
  } @else {
    <h3 class="card__title" i18n="@@powerbi_widget.card.empty_header">Header not set</h3>
  }
  <p-button
    pTooltip="Actions"
    i18n-pTooltip="@@common.button.actions"
    tooltipPosition="bottom"
    icon="pi pi-ellipsis-v"
    [rounded]="true"
    [text]="true"
    size="small"
    (click)="actionMenu.toggle($event)" />
</div>

<div class="powerbi__container">
  @if (!isEditing) {
    @if (powerbiConfig) {
      <powerbi-report
        [embedConfig]="powerbiConfig"
        [cssClassName]="'powerbi__report-wrapper'"></powerbi-report>
    }
  } @else {
    <div class="edit-container">
      <carehub-powerbi-widget-configuration
        [initialConfigurationuration]="configuration"
        [powerbiConfig]="powerbiConfig"
        (powerbiConfigChange)="onPowerBiConfigChange($event)"
        #configurationComponent>
      </carehub-powerbi-widget-configuration>
      <div class="edit-container__actions">
        <p-button label="Cancel" severity="secondary" (onClick)="onConfigurationCancel()">
        </p-button>
        <p-button
          label="Update"
          (onClick)="onConfigurationUpdate()"
          [disabled]="!isConfigurationValid()">
        </p-button>
      </div>
    </div>
  }
</div>

<p-menu #actionMenu [model]="actionMenuItems" [popup]="true" appendTo="body"> </p-menu>
